import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  QueryList,
  SimpleChanges,
  ViewChild,
  ViewChildren,
} from '@angular/core';
import { FormControl } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { AgGridComponent } from 'libs/shared/src/lib/ag-grid/ag-grid.component';

@Component({
  selector: 'piqet-angular-portlet',
  templateUrl: './portlet.component.html',
  styleUrls: ['./portlet.component.css'],
})
export class PortletComponent implements OnChanges, AfterViewInit, OnInit {
  @Input() columnDefs: any;
  @Input() context: any;
  @Input() autoGroupColumnDef: any;
  @Input() treeData = false;
  @Input() selectedStatus = false;
  @Input() isGridRender = false;
  @Input() isAnimateRows = false;
  @Input() isCheckOrgaizationReport = false;
  @Input() headerAlign = false;
  @Input() isSetWidth = false;
  @Input() isPremium = false;
  @Input() isCheckOrganization = false;
  @Input() showDropDown = false;
  @Input() statusList: any;
  @Input() showOrgDropdown: any;
  @Input() organizationList: any;
  @Input() GridRenderForPackageConfiguration = false;
  @Input() frameworkComponents: any;
  @Input() headerBtn: any;
  @Input() importProject: any;
  @Input() adminCopyOrganization: any;
  @Input() testAutomation: any;
  @Input() fetchDestination: any;
  @Input() downloadFile: any;
  @Input() importRefresh: any;
  @Input() importProjectNew: any; //For New Format button
  @Input() addMappingData: any; //For New Format button
  @Input() headerBtnName: any;
  @Input() gridData: any;
  @Input() class: any;
  @Input() pageNo: any;
  @Input() searchInputSize: any;
  @Input() isInvoice!: boolean;
  @Input() customConversionData: any;
  @Input() hidePagination: any;
  @Input() hideSearch: any;
  @Input() gridHeader: any;
  @Input() gridHeaderTooltip: any;
  @Input() isClearSearch: any = false;
  @Input() disableButton = false;
  @Input() isSearchInputPosition!: boolean;
  @Input() error: any;
  @Input() hideSideBar = true;
  @Input() gridName = '';
  @Input() gridConfig: any = [];
  @Input() inlineEdit = false;
  @Input() createAccess = true;
  @Input() scenarioId: any;
  @Input() showNotification = false;
  @Input() showErrorInAccordian = false;
  @Input() sliderValue = 0;
  @Input() recycleCreditId = 0;
  @Input() eleId: any;
  @Input() stepCount: any;
  @Input() stepTitle: any;
  @Input() stepText: any;
  @Input() stepPos: any;
  @Input() stepCountGrid: any;
  @Input() stepTitleGrid: any;
  @Input() stepTextGrid: any;
  @Input() stepPositionGrid: any;
  @Input() isInlineGrid: boolean = false;
  @Input() isChekIniline: boolean = false;
  @Input() isEOLGrid: boolean = false;
  @Input() isPreferenceScreen = false;
  @Input() showUserNotification = false;
  @Input() isServerSide = false;
  @Input() totalCount: number = 0;
  @Input() downloadImportTemplate: any;
  @Input() downloadOrganizationTemplate: any;
  @Input() importExcel: any;
  @Input() addNewOrgMap: any;
  @Input() importBtn: any;
  @Input() buttonName = '';

  @Output() openBtnModal = new EventEmitter<any>();
  @Output() handleUserImportEvent = new EventEmitter<any>();
  @Output() openTestAutomation = new EventEmitter<any>();
  @Output() openAdminCopyOrganization = new EventEmitter<any>();
  @Output() refreshImport = new EventEmitter<any>();
  @Output() openImportModal = new EventEmitter<any>();
  @Output() openAddMappingModal = new EventEmitter<any>();
  @Output() paginationChangeEvent = new EventEmitter<any>();
  @Output() changeRowOrder = new EventEmitter<any>();
  @Output() sortChangeEvent = new EventEmitter<any>();
  @Output() onCellEditingRecord = new EventEmitter<any>();
  @Output() onInputFieldClick = new EventEmitter<any>();
  @Output() searchEvent = new EventEmitter<any>();
  @Output() allDataEvent = new EventEmitter<any>();
  @Output() editDataEvent = new EventEmitter<any>();
  @Output() handleImportUserError = new EventEmitter<any>();
  @Output() inlineDataEditEvent = new EventEmitter<any>();
  @Output() guidedTourEvent = new EventEmitter<any>();
  @Output() guidedTourPrevEvent = new EventEmitter<any>();
  @Output() changeStatusData = new EventEmitter<any>();
  @Output() downloadImport = new EventEmitter<any>();
  @Output() downloadOrganizationTemplateEmit = new EventEmitter<any>();
  @Output() importExcelTemplate = new EventEmitter<any>();
  @Output() addOrgMapEvent = new EventEmitter<any>();
  @Output() redirectToImportProject = new EventEmitter<any>();
  isHovered = false;
  activatedRoute: any;
  isListOfSuppliers: any;
  isProductProjectPage: any;
  isTeamMembershipDetails: any;
  isProjectScreen: any;
  isSearchInput = true;
  searchedKPI: any;
  source: any;
  searchControl = new FormControl('');
  gridDataReplica: any = [];
  mapToReplica = true;
  supressPagination = false;
  isShowClearIcon = false;
  originalImageSrc = './assets/icons/add-record.svg';
  hoverImageSrc = './assets/icons/add-record-hover.svg';
  disableImageSrc = './assets/icons/add-record-disable.svg';

  @ViewChild('searchFilter') searchFilter!: ElementRef;
  @ViewChild(AgGridComponent) agGridComponent!: AgGridComponent;
  @ViewChild('grid') gridComponent!: AgGridComponent;

  constructor(public route: ActivatedRoute) {
    this.activatedRoute = this.route.snapshot.routeConfig?.path;
  }
  ngOnInit() {
    if (
      this.gridName == 'Project scenario wholesale list' ||
      this.gridName == 'Filling List' ||
      this.gridName == 'Pack conversion' ||
      this.gridName == 'Project Scenario Materila List' ||
      this.gridName == 'Retail list' ||
      this.gridName == 'Project scenario consumer list'
    ) {
      this.isProjectScreen = true;
    }
    switch (!!this.gridHeader && this.gridHeader?.toLowerCase()) {
      case 'list of suppliers':
        this.isListOfSuppliers = true;
        this.isTeamMembershipDetails = false;
        break;
      case 'team membership details':
        this.isListOfSuppliers = false;
        this.isTeamMembershipDetails = true;
        break;
    }
    if (this.gridName?.toLowerCase()?.includes('prod')) {
      this.isProductProjectPage = true;
    } else {
      this.isProductProjectPage = false;
    }
  }

  onNext = (): void => {
    this.guidedTourEvent.emit();
  };

  onPrev = (): void => {
    this.guidedTourPrevEvent.emit();
  };

  search(event: any) {
    this.searchEvent.emit(event);
  }

  callFilter(event: any) {
    const value = event.target.value;
    this.isShowClearIcon = !!value.length;
    if (this.isServerSide) {
      this.mapToReplica = false;
      this.searchEvent.emit(value);
    } else {
      if (!value.length) {
        return this.clearSearchBox();
      }
      this.agGridComponent.onGridFilterTriggered(event);
    }
  }

  refreshImportData() {
    this.refreshImport.emit();
  }

  downloadTemplate() {
    this.downloadImport.emit();
  }
  downloadOrganizationTemplateFunc() {
    this.downloadOrganizationTemplateEmit.emit();
  }

  importExcelTemplates() {
    this.importExcelTemplate.emit();
  }
  addOrgMap() {
    this.addOrgMapEvent.emit();
  }

  redirectToImportExcel() {
    this.redirectToImportProject.emit();
  }

  getAll() {
    if (this.gridData.data.length !== this.gridData.recordsTotal && !this.searchControl.value) {
      this.mapToReplica = false;
      this.allDataEvent.emit();
    }
  }

  createCustomConversion() {
    this.gridComponent.addRecord(
      this.headerBtnName,
      this.sliderValue,
      this.scenarioId,
      this.recycleCreditId
    );
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.isServerSide) {
      this.gridData = changes['gridData'].currentValue;
      this.gridDataReplica = this.gridData;
    }
    if (this.mapToReplica) {
      this.gridDataReplica = this.gridData;
      this.clearSearchBox();
    }
    if (this.showErrorInAccordian) {
      this.showNotification = true;
    }
    this.supressPagination = false;
    if (this.headerBtn?.includes('fa fa-plus')) {
      if (this.disableButton) {
        // Change the headerBtn image when the button is disabled
        this.headerBtn = `<img class="fa fa-plus" width="60" height="60" src="${this.disableImageSrc}">`;
      } else {
        this.headerBtn = `<img class="fa fa-plus" width="60" height="60" src="${this.originalImageSrc}">`;
      }
    }
  }

  commonInputSearch(term: string, item: any) {
    return item.name.toLowerCase().includes(term.toLowerCase());
  }

  changeImageOnHover(isHovered: boolean): void {
    this.isHovered = isHovered;
    if (this.disableButton) {
      this.headerBtn = `<img class="fa fa-plus" width="60" height="60" src="${this.disableImageSrc}">`;
    } else {
      this.headerBtn = `<img class="fa fa-plus" width="60" height="60" src="${
        isHovered ? this.hoverImageSrc : this.originalImageSrc
      }">`;
    }
  }
  clearSearchBox() {
    this.isShowClearIcon = false;
    this.searchControl.setValue(null);
    if (this.isServerSide) {
      this.searchEvent.emit('');
    } else {
      this.agGridComponent?.onGridFilterTriggered('');
    }
  }

  changeStatus(data: any) {
    this.selectedStatus = data;
    this.changeStatusData.emit(data);
  }

  ngAfterViewInit() {
    this.clearSearchBox();
  }

  handleIncorrectDataAction() {
    this.handleImportUserError.emit();
  }

  startTour() {}
}
